const projects = [
  {
    title: "Portfolio Website",
    description:
      "Designed and built a responsive single-page portfolio with an interactive Three.js background, custom animated cursor, magnetic hover effects, and scroll reveal animations. The experience includes touch-friendly fallbacks and reduced-motion support.",
    tech: "React • JavaScript • CSS • Three.js • React Three Fiber",
    repository: "https://github.com/dtomlinson44/my-portfolio",
    linkLabel: "View Repository",
  },
  {
    title: "Cardinals Command Center",
    description:
      "Built a responsive St. Louis Cardinals dashboard for schedules, scores, standings, game context, and player performance. It uses live and cached MLB Stats API data to power daily briefings, roster insights, playoff races, and an automatically updating Game Center.",
    tech: "Next.js • React • TypeScript • Tailwind CSS • MLB Stats API",
    repository: "https://github.com/dtomlinson44/cardinals-command-center",
    linkLabel: "View Repository",
  },
  {
    title: "More Projects in Progress",
    description:
      "Developing experimental projects with newer technologies to broaden my toolkit and gain experience with more interactive, performance-intensive applications.",
    tech: "Three.js • WebGL • Godot",
    repository: "https://github.com/dtomlinson44",
    linkLabel: "Explore GitHub",
  },
];

function ProjectsPreview() {
  return (
    <section className="section alt-section scroll-reveal" id="projects">
      <div className="container">
        <div className="section-heading">
          <p className="section-tag">Projects</p>
          <h2>Some things I’m working on</h2>
        </div>

        <div className="projects-grid">
          {projects.map((project) => (
            <article className="project-card" key={project.title}>
              <h3>{project.title}</h3>
              <p>{project.description}</p>
              <span className="project-tech">{project.tech}</span>
              <a
                href={project.repository}
                target="_blank"
                rel="noreferrer"
                className="btn project-link magnetic"
                aria-label={`${project.linkLabel} for ${project.title}`}
              >
                {project.linkLabel}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProjectsPreview;
